import { render, staticRenderFns } from "./DisableMovement.vue?vue&type=template&id=715981dd&"
import script from "./DisableMovement.vue?vue&type=script&lang=js&"
export * from "./DisableMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports